// extracted by mini-css-extract-plugin
export default {"menuContainer":"LanguageSwitcher_menuContainer__1DLwC","button":"LanguageSwitcher_button__17jGE"};